(function () {
  'use strict';

  var root = document.querySelector('[data-scze]');
  if (!root || typeof window.ScartClassicCatalog !== 'function' || !window.SCART_CONFIGURATOR_DATA) return;

  var STORAGE_KEY = 'scart-zone-editor-v2';
  var MIN_SIZE = 0.5;
  var DATA = window.SCART_CONFIGURATOR_DATA;
  var ID_ALIASES = {
    'porsche-911-type-g-2-7': 'type-g-27-30',
    'porsche-911-sc-3-0': 'type-g-27-30',
    'porsche-911-carrera-3-2': 'type-g-32',
    'porsche-911-930-turbo': '930',
    'porsche-911-964-carrera': '964-carrera',
    'porsche-911-964-turbo': '964-turbo',
    'porsche-911-993-carrera': '993-carrera',
    'porsche-911-993-turbo': '993-turbo'
  };
  var catalog = window.ScartClassicCatalog({
    t: function (fr) { return fr; },
    images: {
      typeG: root.dataset.imageTypeG,
      turbo930: root.getAttribute('data-image-930'),
      carrera964: root.getAttribute('data-image-964-carrera'),
      turbo964: root.getAttribute('data-image-964-turbo'),
      carrera993: root.getAttribute('data-image-993-carrera'),
      turbo993: root.getAttribute('data-image-993-turbo')
    },
    badges: {}
  });

  function resolveAsset(file) {
    if (!file) return '';
    return (root.dataset.assetBaseUrl || '/cdn/shop/t/1/assets/') + file;
  }

  DATA.vehicles.forEach(function (vehicle) {
    if (ID_ALIASES[vehicle.id]) return;
    catalog.cars[vehicle.id] = {
      id: vehicle.id,
      name: vehicle.displayName,
      description: vehicle.description,
      architecture: vehicle.architecture,
      caption: vehicle.caption,
      image: resolveAsset(vehicle.drawingAsset),
      alt: 'Vue technique de dessous ' + vehicle.displayName,
      zones: (vehicle.zones || []).map(function (zone) {
        return {
          id: zone.id,
          n: zone.name || zone.n || zone.id,
          d: zone.description || zone.d || '',
          rects: (zone.rects || []).map(function (rect) { return rect.map(Number); }),
          products: zone.products || []
        };
      })
    };
  });

  var zoneOverrides = Object.assign(
    {},
    window.ScartClassicZoneOverrides || {},
    window.ScartConfiguratorDraftZones || {}
  );
  Object.keys(zoneOverrides).forEach(function (carId) {
    if (!catalog.cars[carId]) return;
    catalog.cars[carId].zones.forEach(function (zone) {
      var rects = zoneOverrides[carId] && zoneOverrides[carId][zone.id];
      if (Array.isArray(rects)) zone.rects = rects.map(function (rect) { return rect.map(Number); });
    });
  });

  // One review item per actual drawing. Variants that share the same underside
  // (PSE/non-PSE, engine sizes, etc.) expose the union of their zones once.
  var reviewTargets = {};
  var routeToFamily = {};
  catalog.families = {};
  DATA.families.forEach(function (family) {
    var targetIds = [];
    (family.vehicleIds || []).forEach(function (vehicleId) {
      var carId = ID_ALIASES[vehicleId] || vehicleId;
      routeToFamily[vehicleId] = family.id;
      routeToFamily[carId] = family.id;
      if (catalog.cars[carId] && targetIds.indexOf(carId) === -1) targetIds.push(carId);
    });
    if (!targetIds.length) return;

    var first = catalog.cars[targetIds[0]];
    var zoneMap = {};
    targetIds.forEach(function (carId) {
      catalog.cars[carId].zones.forEach(function (zone) {
        if (!zoneMap[zone.id]) {
          zoneMap[zone.id] = {
            id: zone.id,
            n: zone.n,
            d: zone.d,
            rects: cloneRects(zone.rects),
            products: zone.products || []
          };
        }
      });
    });
    catalog.cars[family.id] = {
      id: family.id,
      name: family.name,
      description: first.description,
      architecture: first.architecture,
      caption: first.caption,
      image: resolveAsset(family.drawingAsset) || first.image,
      alt: 'Vue technique de dessous ' + family.name,
      zones: Object.keys(zoneMap).sort().map(function (zoneId) { return zoneMap[zoneId]; })
    };
    reviewTargets[family.id] = {
      carIds: targetIds,
      previewCarId: (family.vehicleIds || [])[0] || targetIds[0]
    };
    catalog.families[family.id] = {
      label: family.brand + ' · ' + family.generation,
      versions: [{ id: family.id, label: family.name }]
    };
  });

  var refs = {
    nav: root.querySelector('[data-scze-nav]'),
    select: root.querySelector('[data-scze-select]'),
    family: root.querySelector('[data-scze-family]'),
    title: root.querySelector('[data-scze-title]'),
    count: root.querySelector('[data-scze-count]'),
    status: root.querySelector('[data-scze-status]'),
    stage: root.querySelector('[data-scze-stage]'),
    image: root.querySelector('[data-scze-image]'),
    zones: root.querySelector('[data-scze-zones]'),
    list: root.querySelector('[data-scze-list]'),
    inspector: root.querySelector('[data-scze-inspector]'),
    empty: root.querySelector('[data-scze-empty]'),
    form: root.querySelector('[data-scze-form]'),
    zoneTitle: root.querySelector('[data-scze-zone-title]'),
    tabs: root.querySelector('[data-scze-rect-tabs]'),
    preview: root.querySelector('[data-scze-preview]'),
    next: root.querySelector('[data-scze-next]'),
    validate: root.querySelector('[data-scze-validate]'),
    reject: root.querySelector('[data-scze-reject]'),
    rejectForm: root.querySelector('[data-scze-reject-form]'),
    rejectCancel: root.querySelector('[data-scze-reject-cancel]'),
    reason: root.querySelector('[data-scze-reason]'),
    reviewTitle: root.querySelector('[data-scze-review-title]'),
    reviewDetail: root.querySelector('[data-scze-review-detail]'),
    toast: root.querySelector('[data-scze-toast]')
  };

  var reviews = { version: 2, families: {}, cars: {} };
  var reviewFilter = 'pending';
  var reviewerName = 'Brieuc';

  var originals = {};
  Object.keys(catalog.cars).forEach(function (carId) {
    originals[carId] = {};
    catalog.cars[carId].zones.forEach(function (zone) {
      originals[carId][zone.id] = cloneRects(zone.rects);
    });
  });

  var saved = readSaved();
  applySaved();

  var state = {
    carId: validCar(new URL(window.location.href).searchParams.get('car')) || firstReviewCar(),
    zoneId: null,
    rectIndex: 0,
    drag: null
  };

  function cloneRects(rects) {
    return (rects || []).map(function (rect) { return rect.map(Number); });
  }

  function validCar(carId) {
    if (!carId) return null;
    var familyId = routeToFamily[carId] || carId;
    return catalog.cars[familyId] && reviewTargets[familyId] ? familyId : null;
  }

  function firstReviewCar() {
    var versions = allVersions();
    return versions.length ? versions[0].version.id : '930';
  }

  function readSaved() {
    try {
      var value = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '{}');
      return value && typeof value === 'object' ? value : {};
    } catch (_) {
      return {};
    }
  }

  function applySaved() {
    Object.keys(saved).forEach(function (carId) {
      if (!catalog.cars[carId] || !saved[carId]) return;
      catalog.cars[carId].zones.forEach(function (zone) {
        var rects = saved[carId][zone.id];
        if (Array.isArray(rects) && rects.every(validRect)) zone.rects = cloneRects(rects);
      });
    });
  }

  function validRect(rect) {
    return Array.isArray(rect) && rect.length === 4 && rect.every(function (value) { return Number.isFinite(Number(value)); });
  }

  function persistCar() {
    var car = catalog.cars[state.carId];
    var changed = {};
    car.zones.forEach(function (zone) {
      if (JSON.stringify(zone.rects) !== JSON.stringify(originals[state.carId][zone.id])) changed[zone.id] = cloneRects(zone.rects);
    });
    if (Object.keys(changed).length) saved[state.carId] = changed;
    else delete saved[state.carId];
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(saved));
    updateStatus();
    renderNavigationState();
    renderReview();
  }

  function allVersions() {
    var result = [];
    Object.keys(catalog.families).forEach(function (familyId) {
      var family = catalog.families[familyId];
      family.versions.forEach(function (version) {
        if (catalog.cars[version.id]) result.push({ familyId: familyId, family: family.label, version: version });
      });
    });
    return result;
  }

  function familyFor(carId) {
    return allVersions().filter(function (entry) { return entry.version.id === carId; })[0];
  }

  function reviewFor(carId) {
    return (reviews.families && reviews.families[carId]) || { status: 'pending', reason: '', reviewer: '', updatedAt: 0, published: false, locked: false };
  }

  function reviewLabel(status) {
    if (status === 'validated') return 'Validé';
    if (status === 'rejected') return 'À revoir';
    return 'À valider';
  }

  function matchesReviewFilter(carId) {
    return reviewFilter === 'all' || reviewFor(carId).status === reviewFilter;
  }

  function buildNavigation() {
    refs.nav.replaceChildren();
    refs.select.replaceChildren();
    Object.keys(catalog.families).forEach(function (familyId) {
      var family = catalog.families[familyId];
      var visibleVersions = family.versions.filter(function (version) { return matchesReviewFilter(version.id); });
      if (!visibleVersions.length) return;
      var group = document.createElement('div');
      group.className = 'scze__nav-group';
      var title = document.createElement('p');
      title.className = 'scze__nav-group-title';
      title.textContent = family.label;
      group.appendChild(title);

      var optionGroup = document.createElement('optgroup');
      optionGroup.label = family.label;
      visibleVersions.forEach(function (version) {
        var car = catalog.cars[version.id];
        if (!car) return;
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'scze__nav-button';
        button.dataset.carId = version.id;
        button.innerHTML = '<span></span><small></small>';
        button.querySelector('span').textContent = version.label;
        button.querySelector('small').textContent = reviewLabel(reviewFor(version.id).status);
        button.addEventListener('click', function () { selectCar(version.id); });
        group.appendChild(button);

        var option = document.createElement('option');
        option.value = version.id;
        option.textContent = version.label + ' - ' + reviewLabel(reviewFor(version.id).status);
        optionGroup.appendChild(option);
      });
      refs.nav.appendChild(group);
      refs.select.appendChild(optionGroup);
    });
    var visibleCurrent = refs.nav.querySelector('[data-car-id="' + state.carId + '"]');
    if (!visibleCurrent) {
      var first = refs.nav.querySelector('[data-car-id]');
      if (first) state.carId = first.dataset.carId;
    }
  }

  function selectCar(carId) {
    if (!validCar(carId)) return;
    state.carId = carId;
    state.zoneId = null;
    state.rectIndex = 0;
    var url = new URL(window.location.href);
    url.searchParams.set('car', carId);
    window.history.replaceState({}, '', url.pathname + url.search + url.hash);
    renderCar();
  }

  function renderCar() {
    var car = catalog.cars[state.carId];
    if (!car) return;
    var familyEntry = familyFor(state.carId);
    refs.family.textContent = familyEntry ? familyEntry.family : '911 classiques';
    refs.title.textContent = car.name;
    refs.count.textContent = car.zones.length + (car.zones.length > 1 ? ' zones' : ' zone');
    refs.image.src = car.image;
    refs.image.alt = car.alt || car.name;
    refs.preview.href = '/pages/configurateur-test?car=' + encodeURIComponent(reviewTargets[state.carId].previewCarId);
    refs.select.value = state.carId;
    renderZones();
    renderList();
    renderInspector();
    renderNavigationState();
    updateStatus();
    renderReview();
  }

  function renderNavigationState() {
    root.querySelectorAll('[data-car-id]').forEach(function (button) {
      var id = button.dataset.carId;
      button.classList.toggle('is-active', id === state.carId);
      button.classList.toggle('is-edited', Boolean(saved[id]));
      var small = button.querySelector('small');
      if (small) {
        small.textContent = saved[id] ? 'Modifié' : reviewLabel(reviewFor(id).status);
      }
      button.dataset.reviewStatus = reviewFor(id).status;
    });
  }

  function renderZones() {
    refs.zones.replaceChildren();
    var car = catalog.cars[state.carId];
    car.zones.forEach(function (zone) {
      zone.rects.forEach(function (rect, index) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'scze__zone';
        if (state.zoneId === zone.id && state.rectIndex === index) button.classList.add('is-selected');
        button.dataset.zoneId = zone.id;
        button.dataset.rectIndex = String(index);
        button.setAttribute('aria-label', zone.n + ', rectangle ' + (index + 1));
        applyRectStyle(button, rect);

        var label = document.createElement('span');
        label.className = 'scze__zone-label';
        label.textContent = zone.n + (zone.rects.length > 1 ? ' ' + (index + 1) : '');
        button.appendChild(label);
        ['tl', 'tr', 'bl', 'br'].forEach(function (corner) {
          var handle = document.createElement('i');
          handle.className = 'scze__handle scze__handle--' + corner;
          handle.dataset.handle = corner;
          button.appendChild(handle);
        });
        button.addEventListener('click', function () { selectRect(zone.id, index); });
        button.addEventListener('keydown', nudgeWithKeyboard);
        refs.zones.appendChild(button);
      });
    });
  }

  function applyRectStyle(element, rect) {
    element.style.setProperty('--l', rect[0] + '%');
    element.style.setProperty('--t', rect[1] + '%');
    element.style.setProperty('--w', rect[2] + '%');
    element.style.setProperty('--h', rect[3] + '%');
  }

  function renderList() {
    refs.list.replaceChildren();
    catalog.cars[state.carId].zones.forEach(function (zone) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'scze__zone-row';
      button.dataset.listZone = zone.id;
      if (zone.id === state.zoneId) button.classList.add('is-active');
      var copy = document.createElement('span');
      var name = document.createElement('b');
      var meta = document.createElement('small');
      name.textContent = zone.n;
      meta.textContent = zone.rects.length ? summarizeRects(zone.rects) : 'Zone masquée - aucun rectangle';
      copy.appendChild(name);
      copy.appendChild(meta);
      var arrow = document.createElement('i');
      arrow.textContent = '→';
      button.appendChild(copy);
      button.appendChild(arrow);
      button.addEventListener('click', function () {
        if (!zone.rects.length) addRect(zone.id);
        else selectRect(zone.id, 0);
      });
      refs.list.appendChild(button);
    });
  }

  function summarizeRects(rects) {
    if (rects.length > 1) return rects.length + ' rectangles';
    return rects[0].map(function (value) { return format(value); }).join(' · ') + ' %';
  }

  function selectedZone() {
    return catalog.cars[state.carId].zones.filter(function (zone) { return zone.id === state.zoneId; })[0] || null;
  }

  function selectedRect() {
    var zone = selectedZone();
    return zone && zone.rects[state.rectIndex] ? zone.rects[state.rectIndex] : null;
  }

  function selectRect(zoneId, index) {
    state.zoneId = zoneId;
    state.rectIndex = index;
    renderZones();
    renderList();
    renderInspector();
  }

  function renderInspector() {
    var zone = selectedZone();
    var rect = selectedRect();
    refs.empty.hidden = Boolean(zone && rect);
    refs.form.hidden = !zone || !rect;
    if (!zone || !rect) return;
    refs.zoneTitle.textContent = zone.n;
    refs.tabs.replaceChildren();
    zone.rects.forEach(function (_, index) {
      var tab = document.createElement('button');
      tab.type = 'button';
      tab.className = 'scze__rect-tab' + (index === state.rectIndex ? ' is-active' : '');
      tab.textContent = 'Rectangle ' + (index + 1);
      tab.addEventListener('click', function () { selectRect(zone.id, index); });
      refs.tabs.appendChild(tab);
    });
    updateFields(rect);
  }

  function updateFields(rect) {
    root.querySelectorAll('[data-scze-field]').forEach(function (input) {
      input.value = format(rect[Number(input.dataset.sczeField)]);
    });
  }

  function updateSelectedViews(rect) {
    var button = refs.zones.querySelector('[data-zone-id="' + state.zoneId + '"][data-rect-index="' + state.rectIndex + '"]');
    if (button) applyRectStyle(button, rect);
    updateFields(rect);
    var row = refs.list.querySelector('[data-list-zone="' + state.zoneId + '"] small');
    var zone = selectedZone();
    if (row && zone) row.textContent = summarizeRects(zone.rects);
  }

  function updateStatus() {
    var changed = Boolean(saved[state.carId]);
    var review = reviewFor(state.carId);
    refs.status.textContent = changed
      ? 'Modifié sur cet appareil'
      : review.status === 'validated'
        ? 'Coordonnées enregistrées en test'
        : review.status === 'rejected'
          ? 'Correction demandée'
          : 'Placement proposé';
    refs.status.classList.toggle('is-dirty', changed);
  }

  function renderReview() {
    var review = reviewFor(state.carId);
    var changed = Boolean(saved[state.carId]);
    refs.reviewTitle.textContent = changed && review.status === 'validated'
      ? 'Modification à réenregistrer'
      : reviewLabel(review.status);
    if (review.status === 'rejected') {
      refs.reviewDetail.textContent = 'Motif de ' + (review.reviewer || 'Brieuc') + ' : ' + review.reason;
    } else if (review.status === 'validated') {
      refs.reviewDetail.textContent = review.locked
        ? 'Référence déjà en production, verrouillée dans cet outil.'
        : 'Validé par ' + (review.reviewer || 'Brieuc') + ' pour le configurateur de test.';
    } else {
      refs.reviewDetail.textContent = 'Vérifiez le parcours et le placement de chaque zone.';
    }
    refs.validate.disabled = Boolean(review.locked);
    refs.reject.disabled = Boolean(review.locked);
    refs.rejectForm.hidden = true;
    refs.reason.value = review.status === 'rejected' ? review.reason : '';
  }

  function format(value) {
    return String(Math.round(Number(value) * 10) / 10).replace('.0', '');
  }

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, Math.round(value * 10) / 10));
  }

  root.querySelectorAll('[data-scze-field]').forEach(function (input) {
    input.addEventListener('input', function () {
      var rect = selectedRect();
      if (!rect) return;
      var index = Number(input.dataset.sczeField);
      var value = Number(input.value);
      if (!Number.isFinite(value)) return;
      if (index === 0) rect[0] = clamp(value, 0, 100 - rect[2]);
      if (index === 1) rect[1] = clamp(value, 0, 100 - rect[3]);
      if (index === 2) rect[2] = clamp(value, MIN_SIZE, 100 - rect[0]);
      if (index === 3) rect[3] = clamp(value, MIN_SIZE, 100 - rect[1]);
      updateSelectedViews(rect);
      persistCar();
    });
  });

  function nudgeWithKeyboard(event) {
    if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) return;
    event.preventDefault();
    var rect = selectedRect();
    if (!rect) return;
    var step = event.shiftKey ? 1 : 0.1;
    if (event.key === 'ArrowLeft') rect[0] = clamp(rect[0] - step, 0, 100 - rect[2]);
    if (event.key === 'ArrowRight') rect[0] = clamp(rect[0] + step, 0, 100 - rect[2]);
    if (event.key === 'ArrowUp') rect[1] = clamp(rect[1] - step, 0, 100 - rect[3]);
    if (event.key === 'ArrowDown') rect[1] = clamp(rect[1] + step, 0, 100 - rect[3]);
    updateSelectedViews(rect);
    persistCar();
  }

  refs.stage.addEventListener('pointerdown', function (event) {
    var button = event.target.closest('.scze__zone');
    if (!button) return;
    event.preventDefault();
    var zoneId = button.dataset.zoneId;
    var rectIndex = Number(button.dataset.rectIndex);
    if (state.zoneId !== zoneId || state.rectIndex !== rectIndex) {
      state.zoneId = zoneId;
      state.rectIndex = rectIndex;
      refs.zones.querySelectorAll('.scze__zone').forEach(function (zoneButton) {
        zoneButton.classList.toggle('is-selected', zoneButton === button);
      });
      renderList();
      renderInspector();
    }
    var rect = selectedRect();
    if (!rect) return;
    state.drag = {
      pointerId: event.pointerId,
      button: button,
      handle: event.target.dataset.handle || 'move',
      startX: event.clientX,
      startY: event.clientY,
      startRect: rect.slice(),
      stageRect: refs.stage.getBoundingClientRect()
    };
    button.setPointerCapture(event.pointerId);
  });

  refs.stage.addEventListener('pointermove', function (event) {
    if (!state.drag || state.drag.pointerId !== event.pointerId) return;
    var rect = selectedRect();
    if (!rect) return;
    var drag = state.drag;
    var dx = (event.clientX - drag.startX) / drag.stageRect.width * 100;
    var dy = (event.clientY - drag.startY) / drag.stageRect.height * 100;
    var s = drag.startRect;
    var handle = drag.handle;
    if (handle === 'move') {
      rect[0] = clamp(s[0] + dx, 0, 100 - s[2]);
      rect[1] = clamp(s[1] + dy, 0, 100 - s[3]);
    } else {
      var right = s[0] + s[2];
      var bottom = s[1] + s[3];
      if (handle.indexOf('l') !== -1) {
        rect[0] = clamp(s[0] + dx, 0, right - MIN_SIZE);
        rect[2] = clamp(right - rect[0], MIN_SIZE, 100 - rect[0]);
      }
      if (handle.indexOf('r') !== -1) rect[2] = clamp(s[2] + dx, MIN_SIZE, 100 - s[0]);
      if (handle.indexOf('t') !== -1) {
        rect[1] = clamp(s[1] + dy, 0, bottom - MIN_SIZE);
        rect[3] = clamp(bottom - rect[1], MIN_SIZE, 100 - rect[1]);
      }
      if (handle.indexOf('b') !== -1) rect[3] = clamp(s[3] + dy, MIN_SIZE, 100 - s[1]);
    }
    updateSelectedViews(rect);
  });

  function finishDrag(event) {
    if (!state.drag || state.drag.pointerId !== event.pointerId) return;
    state.drag = null;
    persistCar();
  }
  refs.stage.addEventListener('pointerup', finishDrag);
  refs.stage.addEventListener('pointercancel', finishDrag);

  function addRect(zoneId) {
    var zone = catalog.cars[state.carId].zones.filter(function (item) { return item.id === zoneId; })[0];
    if (!zone) return;
    var source = zone.rects.length ? zone.rects[Math.min(state.rectIndex, zone.rects.length - 1)] : [40, 40, 20, 20];
    var duplicate = [clamp(source[0] + 2, 0, 100 - source[2]), clamp(source[1] + 2, 0, 100 - source[3]), source[2], source[3]];
    zone.rects.push(duplicate);
    persistCar();
    selectRect(zone.id, zone.rects.length - 1);
  }

  root.querySelector('[data-scze-add]').addEventListener('click', function () {
    if (state.zoneId) addRect(state.zoneId);
  });

  root.querySelector('[data-scze-delete]').addEventListener('click', function () {
    var zone = selectedZone();
    if (!zone) return;
    zone.rects.splice(state.rectIndex, 1);
    persistCar();
    if (zone.rects.length) {
      state.rectIndex = Math.max(0, state.rectIndex - 1);
      renderZones(); renderList(); renderInspector();
    } else {
      state.zoneId = null; state.rectIndex = 0;
      renderZones(); renderList(); renderInspector();
    }
  });

  function resetCar(carId) {
    if (!catalog.cars[carId]) return;
    catalog.cars[carId].zones.forEach(function (zone) { zone.rects = cloneRects(originals[carId][zone.id]); });
    delete saved[carId];
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(saved));
    state.zoneId = null;
    state.rectIndex = 0;
    renderCar();
  }

  root.querySelector('[data-scze-reset-car]').addEventListener('click', function () {
    if (window.confirm('Réinitialiser toutes les zones de ' + catalog.cars[state.carId].name + ' ?')) resetCar(state.carId);
  });

  root.querySelector('[data-scze-reset-all]').addEventListener('click', function () {
    if (!window.confirm('Effacer toutes les modifications enregistrées sur cet appareil ?')) return;
    Object.keys(catalog.cars).forEach(function (carId) {
      catalog.cars[carId].zones.forEach(function (zone) { zone.rects = cloneRects(originals[carId][zone.id]); });
    });
    saved = {};
    window.localStorage.removeItem(STORAGE_KEY);
    state.zoneId = null;
    renderCar();
    showToast('Toutes les zones ont été réinitialisées.');
  });

  function exportCar(carId) {
    var zones = {};
    catalog.cars[carId].zones.forEach(function (zone) { zones[zone.id] = cloneRects(zone.rects); });
    return { car: carId, name: catalog.cars[carId].name, zones: zones };
  }

  function exportChanged() {
    var result = {};
    Object.keys(saved).forEach(function (carId) { result[carId] = exportCar(carId).zones; });
    return result;
  }

  function copyText(value, message) {
    var text = JSON.stringify(value, null, 2);
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).then(function () { showToast(message); }).catch(function () { legacyCopy(text, message); });
    } else legacyCopy(text, message);
  }

  function legacyCopy(text, message) {
    var area = document.createElement('textarea');
    area.value = text;
    area.style.position = 'fixed';
    area.style.opacity = '0';
    document.body.appendChild(area);
    area.select();
    document.execCommand('copy');
    area.remove();
    showToast(message);
  }

  root.querySelector('[data-scze-copy]').addEventListener('click', function () {
    copyText(exportCar(state.carId), 'Coordonnées de ce modèle copiées.');
  });
  root.querySelector('[data-scze-copy-all]').addEventListener('click', function () {
    copyText(exportChanged(), Object.keys(saved).length ? 'Toutes les modifications ont été copiées.' : 'Aucune modification enregistrée.');
  });

  function apiPost(path, payload) {
    return fetch(root.dataset.apiBase + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload || {})
    }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (body) {
        return { status: response.status, body: body };
      });
    });
  }

  function setBusy(button, busy, label) {
    if (!button) return;
    if (busy) {
      button.dataset.previousLabel = button.textContent;
      button.disabled = true;
      button.textContent = label;
    } else {
      button.disabled = false;
      button.textContent = button.dataset.previousLabel || button.textContent;
    }
  }

  function applyDecision(result) {
    if (!result.body.ok) throw new Error(result.body.error || 'L’enregistrement a échoué.');
    reviews.families[state.carId] = result.body.decision;
    (result.body.cars || []).forEach(function (carId) {
      reviews.cars[carId] = result.body.decision;
    });
    if (result.body.decision.status === 'validated') {
      originals[state.carId] = {};
      catalog.cars[state.carId].zones.forEach(function (zone) {
        originals[state.carId][zone.id] = cloneRects(zone.rects);
      });
      delete saved[state.carId];
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(saved));
    }
    buildNavigation();
    renderCar();
  }

  refs.validate.addEventListener('click', function () {
    var review = reviewFor(state.carId);
    if (review.locked) return;
    var car = exportCar(state.carId);
    if (!window.confirm('Enregistrer cette validation et ces zones uniquement dans le configurateur de test pour ' + car.name + ' ?')) return;
    setBusy(refs.validate, true, 'Enregistrement…');
    apiPost('/zones/review', {
      family: car.car,
      zones: car.zones,
      status: 'validated',
      reviewer: reviewerName
    }).then(applyDecision).then(function () {
      showToast('Validation et zones enregistrées dans le configurateur de test.');
    }).catch(function (error) {
      showToast(error.message || 'L’enregistrement a échoué.');
    }).finally(function () {
      setBusy(refs.validate, false);
    });
  });

  refs.reject.addEventListener('click', function () {
    if (reviewFor(state.carId).locked) return;
    refs.rejectForm.hidden = false;
    refs.reason.focus();
  });
  refs.rejectCancel.addEventListener('click', function () { refs.rejectForm.hidden = true; });
  refs.rejectForm.addEventListener('submit', function (event) {
    event.preventDefault();
    var reason = refs.reason.value.trim();
    if (!reason) {
      refs.reason.focus();
      return;
    }
    var submit = refs.rejectForm.querySelector('[type="submit"]');
    setBusy(submit, true, 'Enregistrement…');
    apiPost('/zones/review', {
      family: state.carId,
      status: 'rejected',
      reason: reason,
      reviewer: reviewerName
    }).then(applyDecision).then(function () {
      showToast('Motif enregistré. Le configurateur public reste inchangé.');
    }).catch(function (error) {
      showToast(error.message || 'L’enregistrement a échoué.');
    }).finally(function () {
      setBusy(submit, false);
    });
  });

  refs.next.addEventListener('click', function () {
    var versions = allVersions();
    var currentIndex = versions.findIndex(function (entry) { return entry.version.id === state.carId; });
    for (var offset = 1; offset <= versions.length; offset += 1) {
      var candidate = versions[(currentIndex + offset) % versions.length].version.id;
      if (reviewFor(candidate).status === 'pending') {
        reviewFilter = 'pending';
        syncReviewFilters();
        buildNavigation();
        selectCar(candidate);
        return;
      }
    }
    showToast('Aucun autre parcours en attente.');
  });

  function syncReviewFilters() {
    root.querySelectorAll('[data-scze-review-filter]').forEach(function (button) {
      button.classList.toggle('is-active', button.dataset.sczeReviewFilter === reviewFilter);
    });
  }

  root.querySelectorAll('[data-scze-review-filter]').forEach(function (button) {
    button.addEventListener('click', function () {
      reviewFilter = button.dataset.sczeReviewFilter;
      syncReviewFilters();
      buildNavigation();
      renderCar();
    });
  });

  refs.select.addEventListener('change', function () { selectCar(refs.select.value); });

  function loadReviewState() {
    return apiPost('/zones/state', {}).then(function (result) {
      if (!result.body.ok) throw new Error(result.body.error || 'Impossible de charger les validations.');
      reviews = result.body.state || { version: 2, families: {}, cars: {} };
      if (!reviews.families) reviews.families = {};
      if (!reviews.cars) reviews.cars = {};
      buildNavigation();
      renderCar();
    });
  }

  var toastTimer;
  function showToast(message) {
    window.clearTimeout(toastTimer);
    refs.toast.textContent = message;
    refs.toast.hidden = false;
    toastTimer = window.setTimeout(function () { refs.toast.hidden = true; }, 2600);
  }

  buildNavigation();
  renderCar();
  loadReviewState().catch(function (error) {
    showToast(error.message || 'Impossible de charger les validations.');
  });
})();
